import { buildImageAssetMetadataToSave, extractInfoForDeserialization } from '@bingads-webui-campaign/media-metadata-model';
import _ from 'underscore';

export const ViewName = {
  PlacementListView: 'placementListView',
  PlacementEditView: 'placementEditView',
  ImageAdjustView: 'imageAdjustView',
  BackgroundChangeView: 'backgroundChangeView',
};

export const convertMetaData = (resultFilterAndBlurImage) => {
  const combinedEffect = [];
  if (resultFilterAndBlurImage.filter) {
    const filterEffect = buildImageAssetMetadataToSave({
      effectSettings: {
        effectKey: 'DesignerEffects',
        effectOptions: {
          designerEffect: resultFilterAndBlurImage.filter,
        },
      },
    });
    combinedEffect.push(filterEffect);
  }
  if (resultFilterAndBlurImage.blur) {
    const blurEffect = buildImageAssetMetadataToSave({
      effectSettings: {
        effectKey: 'BackgroundBlur',
        effectOptions: {
          backgroundBlur: resultFilterAndBlurImage.blur,
        },
      },
    });
    combinedEffect.push(blurEffect);
  }
  if (combinedEffect.length > 0) {
    return {
      effect: combinedEffect[0].effect,
      combinedEffect,
    };
  }
  return null;
};

const revertMetaDataInner = (metaData) => {
  const combinedEffectArray = _.isArray(metaData.combinedEffect) ? metaData.combinedEffect : _.keys(metaData.combinedEffect).map(key => metaData.combinedEffect[key]);
  if (combinedEffectArray.length > 0) {
    const filterEffect = combinedEffectArray.find(effect => effect.effect.key === 'DesignerEffects');
    const blurEffect = combinedEffectArray.find(effect => effect.effect.key === 'BackgroundBlur');
    return {
      filter: filterEffect ? extractInfoForDeserialization({ obj: filterEffect }) : null,
      blur: blurEffect ? extractInfoForDeserialization({ obj: blurEffect }) : null,
    };
  } else if (metaData.effect) {
    if (metaData.effect.key === 'DesignerEffects') {
      return {
        filter: extractInfoForDeserialization({ obj: metaData }),
        blur: null,
      };
    } else if (metaData.effect.key === 'BackgroundBlur') {
      return {
        filter: null,
        blur: extractInfoForDeserialization({ obj: metaData }),
      };
    }
  }
  return null;
};

export const revertMetaData = (metaData) => {
  const { filter, blur } = revertMetaDataInner(metaData);
  const filterValue = filter ? filter.effectSettings.effectOptions.designerEffect : null;
  const blurValue = blur ? blur.effectSettings.effectOptions.backgroundBlur : null;
  return {
    filter: filterValue,
    blur: blurValue,
  };
};
